// extracted by mini-css-extract-plugin
export var headlinePanel = "blog-detail-masthead-module--headlinePanel--02d51";
export var mastheadImage = "blog-detail-masthead-module--mastheadImage--bb4f6";
export var subheading = "blog-detail-masthead-module--subheading--51fb8";
export var summary = "blog-detail-masthead-module--summary--39ece";
export var topicLink = "blog-detail-masthead-module--topicLink--14b21";
export var wrapper = "blog-detail-masthead-module--wrapper--45f15";